import Vue from 'vue';
import { gsap, Power4 } from 'gsap/all';

Vue.component('header-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            inTransition: false,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {

    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        toggleMenu() {
            if (this.inTransition) {
                return;
            }

            this.inTransition = true;

            if (document.body.classList.contains('menu-open')) {
                this.closeMenu();
            } else {
                this.openMenu();
            }
        },

        closeMenu() {
            if (window.matchMedia('(max-width: 767px)').matches) {
                const onReverseComplete = () => {
                    this.inTransition = false;
                    gsap.set(['.menu-background', '.navigation', '.navigation__item'], { clearProps: 'all' });
                };

                // Closing the menu
                document.body.classList.remove('menu-open');

                gsap.to('.navigation__item', {
                    duration: 0.5, y: 50, autoAlpha: 0, ease: Power4.ease, stagger: -0.1,
                });
                gsap.to('.hamburger__line1', { duration: 0.2, autoAlpha: 1 });
                gsap.to('.hamburger__line2', { duration: 0.2, rotate: 0, y: 0 });
                gsap.to('.hamburger__line3', { duration: 0.2, rotate: 0, y: 0 });
                gsap.to('.menu-background', {
                    duration: 0.8, delay: 0.2, scaleY: 0, ease: Power4.easeInOut, onComplete: onReverseComplete,
                });
            }
        },

        openMenu() {
            const onComplete = () => {
                this.inTransition = false;
            };

            // Opening the menu
            document.body.classList.add('menu-open');
            document.querySelector('.navigation').style.display = 'block';

            gsap.to('.menu-background', { duration: 0.8, scaleY: 1, ease: Power4.easeOut });
            gsap.to('.hamburger__line1', { delay: 0.15, duration: 0.3, autoAlpha: 0 });
            gsap.to('.hamburger__line2', {
                delay: 0.15, duration: 0.3, rotate: '-45deg', y: '4px',
            });
            gsap.to('.hamburger__line3', {
                delay: 0.15, duration: 0.3, rotate: '45deg', y: '-3px',
            });
            gsap.to('.navigation__item', {
                delay: 0.1, duration: 0.6, y: '0', autoAlpha: 1, ease: Power4.ease, stagger: 0.1, onComplete,
            });
        },

    },
});
